export const coinName = [
  "BTC bitcoin",
  "ETH ethereum",
  "XRP ripple",
  "USDT tether",
  "BCH bitcoin-cash",
  "BSV bitcoin-sv",
  "LTC litecoin",
  "BNB binance-coin",
  "EOS eos",
  "XTZ tezos",
  "LINK chainlink",
  "XLM stellar",
  "ADA cardano",
  "LEO unus-sed-leo",
  "XMR monero",
  "TRX tron",
  "HT huobi-token",
  "ETC ethereum-classic",
  "NEO neo",
  "USDC usd-coin",
  "DASH dash",
  "ATOM cosmos",
  "MIOTA iota",
  "ZEC zcash",
  "XEM nem",
  "MKR maker",
  "DOGE dogecoin",
  "ONT ontology",
  "BAT basic-attention-token",
  "ZRX 0x",
  "DGB digibyte",
  "PAX paxos-standard-token",
  "VET vechain",
  "BTG bitcoin-gold",
  "DCR decred",
  "ICX icon",
  "QTUM qtum",
  "TUSD trueusd",
  "ALGO algorand",
  "LSK lisk",
  "REP augur",
  "RVN ravencoin",
  "ENJ enjin-coin",
  "DAI multi-collateral-dai",
  "KNC kyber-network",
  "THETA theta-token",
  "ABBC abbc-coin",
  "BCD bitcoin-diamond",
  "WAVES waves",
  "OMG omisego",
  "SNT status",
  "MONA monacoin",
  "NRG energi",
  "MCO crypto-com",
  "DX dxchain-token",
  "SC siacoin",
  "NANO nano",
  "HOT holo",
  "NMR numeraire",
  "LEND ethlend",
  "ZIL zilliqa",
  "STEEM steem",
  "KMD komodo",
  "BTM bytom",
  "NEXO nexo",
  "QNT quant",
  "XVG verge",
  "SEELE seele",
  "LUNA terra-luna",
  "DATA streamr-datacoin",
  "BTS bitshares",
  "VSYS v-systems",
  "MANA decentraland",
  "REN republic-protocol",
  "HC hypercash",
  "MAID maidsafecoin",
  "PAXG pax-gold",
  "GNT golem-network-tokens",
  "IOST iostoken",
  "RCN ripio-credit-network",
  "ZEN zencash",
  "XZC zcoin",
  "CRPT crypterium",
  "TNT tierion",
  "ARDR ardor",
  "WAXP wax",
  "ANT aragon",
  "ELF aelf",
  "UBT unibright",
  "ETN electroneum",
  "AION aion",
  "LRC loopring",
  "AE aeternity",
  "POWR power-ledger",
  "GXC gxchain",
  "STRAT stratis",
  "WICC waykichain",
  "TOMO tomochain",
  "HNS handshake",
  "NPXS pundi-x",
  "RLC rlc",
  "ELA elastos",
  "ARK ark",
  "PAI project-pai",
  "CTXC cortex",
  "GRIN grin",
  "NULS nuls",
  "WTC waltonchain",
  "BEAM beam",
  "WAN wanchain",
  "MTL metal",
  "CHSB swissborg",
  "TEL telcoin",
  "PIVX pivx",
  "KAN bitkan",
  "PPT populous",
  "FUN funfair",
  "CVC civic",
  "NAS nebulas-token",
  "LOOM loom-network",
  "IOTX iotex",
  "STORJ storj",
  "BNT bancor",
  "ENG enigma-project",
  "OXT orchid",
  "SYS syscoin",
  "GAS gas",
  "LBC library-credit",
  "EDO eidoo",
  "QASH qash",
  "DENT dent",
  "NXT nxt",
  "DRGN dragonchain",
  "POLY polymath-network",
  "GRS groestlcoin",
  "BRD bread",
  "BIX bibox-token",
  "STORM storm",
  "SKY skycoin",
  "ETP metaverse",
  "ITC iot-chain",
  "MDA moeda-loyalty-points",
  "AGI singularitynet",
  "NKN nkn",
  "GO gochain",
  "NEBL neblio",
  "LBA libra-credit",
  "ADX adx-net",
  "EKT educare",
  "QSP quantstamp",
  "XDCE xinfin-network",
  "SMART smartcash",
  "QKC quarkchain",
  "RDN raiden-network-token",
  "RUFF ruff",
  "ACT achain",
  "MFT mainframe",
  "VITE vite",
  "HYDRO hydrogen",
  "OST ost",
  "UUU u-network",
  "PRO propy",
  "SWFTC swftcoin",
  "SNGLS singulardtv",
  "UIP unlimitedip",
  "SOC all-sports",
  "UTK utrust",
  "SMT smartmesh",
  "HIT hitchain",
  "EVX everex",
  "EGT egretia",
  "HPB high-performance-blockchain",
  "ZRC zrcoin",
  "APPC appcoins",
  "GVT genesis-vision",
  "QUN qunqun",
  "MITH mithril",
  "KEY selfkey",
  "BLZ bluzelle",
  "MDT measurable-data-token",
  "HYC hycon",
  "MAN matrix-ai-network",
  "TCT tokenclub",
  "DOCK dock",
  "ETHOS ethos",
  "SNC suncontract",
  "SKM skrumble-network",
  "DLT agrello-delta",
  "VIB viberate",
  "MDS medishares",
  "DBC deepbrain-chain",
  "AST airswap",
  "CNN content-neutrality-network",
  "LYM lympo",
  "POA poa-network",
  "ARN aeron",
  "OCN odyssey",
  "GNX genaro-network",
  "PPP paypie",
  "EDN eden",
  "BTM bitmark",
  "XNS insolar",
  "BRC baer-chain",
  "XIN mixin",
  "AMP synereo",
  "DGD digixdao",
  "KCS kucoin-shares",
  "BCN bytecoin-bcn",
  "CENNZ centrality",
  "XWC whitecoin",
  "RDD reddcoin",
  "STX blockstack",
  "EURS stasis-eurs",
  "CVT cybervein",
  "RPL rocket-pool",
  "TRUE truechain",
  "GNO gnosis-gno",
  "C20 c20",
  "LOKI loki",
  "FCT factom",
  "BZ bit-z-token",
  "CTC credit-tag-chain",
  "SOL sola-token",
  "VTC vertcoin",
  "DAG constellation",
  "MOF molecular-future",
  "CET coinex-token",
  "SHIP shipchain",
  "NXS nexus",
  "META metadium",
  "CND cindicator",
  "B2B b2bx",
  "LA latoken",
  "BLOCK blocknet",
  "KIN kin",
  "REQ request-network",
  "ABT arcblock",
  "SALT salt",
  "IHF invictus-hyperion-fund",
  "CMT cybermiles",
  "CS credits",
  "NAV nav-coin",
  "KCASH kcash",
  "PPC peercoin",
  "PAY tenx",
  "NLG gulden",
  "FSN fusion",
  "TRAC origintrail",
  "UBQ ubiq",
  "REV revain",
  "XPX proximax",
  "PLBT polybius",
  "PRS pressone",
  "XSN stakenet",
  "WABI wabi",
  "BFT bnktothefuture",
  "MLN melon",
  "BCV bitcapitalvendor",
  "SRN sirin-labs-token",
  "TNB time-new-bank",
  "SEAL seal-network",
  "NIM nimiq",
  "GTC game",
  "GAME gamecredits",
  "WPR wepower",
  "PART particl",
  "EMC emercoin",
  "DCN dentacoin",
  "POE poet",
  "LCC litecoin-cash",
  "AMB amber",
  "PI pchain",
  "VIA viacoin",
  "CDT blox",
  "DNT district0x",
  "OAX oax",
  "ZCN 0chain",
  "DTA data",
  "WINGS wings",
  "TRIO tripio",
  "GSC global-social-chain",
  "SOUL phantasma",
  "SNM sonm",
  "QLC qlink",
  "BOX contentbox",
  "MTH monetha",
  "BET dao-casino",
  "COV covesting",
  "MITX morpheus-labs",
  "VIBE vibe",
  "FUEL etherparty",
  "VDG veridocglobal",
  "BCPT blockmason",
  "OLT oneledger",
  "KRL kryll",
  "PRE presearch",
  "CBC cashbet-coin",
  "PHX red-pulse",
  "SUMO sumokoin",
  "DDD scryinfo",
  "CPT cryptaur",
  "TERA tera",
  "LUN lunyr",
  "NCASH nucleus-vision",
  "UKG unikoin-gold",
  "TAU lamden",
  "LET linkeye",
  "XDN digitalnote",
  "NCT polyswarm",
  "HOT hydro-protocol",
  "YEE yee",
  "ZER zero",
  "PNT penta",
  "HMQ humaniq",
  "CV carvertical",
  "MUE monetaryunit",
  "LIFE life",
  "ADC audiocoin",
  "DAX daex",
  "REM remme",
  "AIDOC aidoc",
  "CHAT chatcoin",
  "MVP merculet",
  "NKC nework",
  "DAT datum",
  "ATN atn",
  "MTN medical-chain",
  "TRTL turtlecoin",
  "CPX apex",
  "EXY experty",
  "CPC cpchain",
  "RC russiacoin",
  "STK stk",
  "TIME chronobank",
  "INXT internxt",
  "EKO echolink",
  "MTX matryx",
  "IPL insurepal",
  "DNA encrypgen",
  "AIT aichain",
  "CAPP cappasity",
  "RTE rate3",
  "FDZ friends",
  "PKT playkey",
  "ZXC 0xcert",
  "KICK kick-token",
  "FTI fanstime",
  "UT ulord",
  "SENC sentinel-chain",
  "DATX datx",
  "NCC neurochain",
  "FKX knoxstertoken",
  "COFI coinfi",
  "XBI bitcoin-incognito",
  "ZSC zeusshield",
  "IDT investdigital",
  "PLAY herocoin",
  "TNS transcodium",
  "METM metamorph",
  "AMM micromoney",
  "JET jetcoin",
  "BTW bitwhite",
  "CMT comet",
  "HMC harmonycoin-hmc",
  "HAV havven",
  "BNK bankera",
  "PLC platincoin",
  "KBC karatgold-coin",
  "DTR dynamic-trading-rights",
  "IGNIS ignis",
  "GBYTE byteball",
  "VERI veritaseum",
  "SAI single-collateral-dai",
  "BURST burst",
  "YOU you-coin",
  "1ST firstblood",
  "ODE odem",
  "EMC2 einsteinium",
  "AOA aurora",
  "XMC monero-classic",
  "UQC uquid-coin",
  "IQ everipedia",
  "DMT dmarket",
  "SAN santiment",
  "AEON aeon",
  "MED medibloc",
  "GOT gonetwork",
  "DRG dragon-coins",
  "DGX digix-gold-token",
  "NMC namecoin",
  "SLS salus",
  "DEC darcio-ecosystem-coin",
  "GTO gifto",
  "PCL peculium",
  "GUSD gemini-dollar",
  "QRL quantum-resistant-ledger",
  "UTT uttoken",
  "LBTC lightning-bitcoin",
  "SBD steem-dollars",
  "MOAC moac",
  "BAX babb",
  "NEU neumark",
  "WGR wagerr",
  "JNT jibrel-network",
  "MRPH morpheus-network",
  "TKN tokencard",
  "CAN canyacoin",
  "BTX bitcore",
  "DICE etheroll",
  "TFL trueflip",
  "MET metronome",
  "HVN hive-project",
  "TAAS taas",
  "TTC ttc-protocol",
  "PLR pillar",
  "LKK lykke",
  "EDR endor-protocol",
  "BOX box-token",
  "FLO flo",
  "XAUR xaurum",
  "XCP counterparty",
  "YOYOW yoyow",
  "UTNP universa",
  "ROX robotina",
  "LOC lockchain",
  "NOAH noah-coin",
  "PMA pumapay",
  "VEE blockv",
  "XSPEC spectrecoin",
  "FTC feathercoin",
  "BLK blackcoin",
  "CZR cononchain",
  "RFR refereum",
  "HTML html-coin",
  "INSTAR insights-network",
  "QNTU quanta-utility-token",
  "CPAY cryptopay",
  "DADI dadi",
  "XMY myriad",
  "POT potcoin",
  "BMC blackmoon",
  "CXO cargox",
  "BZNT bezant",
  "TUBE bit-tube",
  "TDX tidex-token",
  "GRID grid",
  "RADS radium",
  "LGO legolas-exchange",
  "SIX six",
  "TFD te-food",
  "TPAY tokenpay",
  "TKY thekey",
  "OK okcash",
  "NPX napoleonx",
  "ABYSS the-abyss",
  "MOBI mobius",
  "INCNT incent",
  "CRW crown",
  "CHP coinpoker",
  "BOS boscoin",
  "LIF winding-tree",
  "CLO callisto-network",
  "XST stealth",
  "PLU pluton",
  "LIKE likecoin",
  "BPT blockport",
  "SLR solarcoin",
  "CURE curecoin",
  "GOLOS golos",
  "SENT sentinel",
  "NGC naga",
  "IOC iocoin",
  "MWAT restart-energy-mwat",
  "VEX vexanium",
  "SUB substratum",
  "XYO xyo-network",
  "VCT valuecybertoken",
  "MRK mark-space",
  "CEEK ceek-vr",
  "YEED yeed",
  "AMLT amlt",
  "DIME dimecoin",
  "UBEX ubex",
  "UFR upfiring",
  "DMD diamond",
  "INT internet-node-token",
  "BTO bottos",
  "PPY peerplays-ppy",
  "TOL tolar",
  "CAG change",
  "EOSDAC eosdac",
  "CBT commerceblock",
  "CARD cardstack",
  "LND lendingblock",
  "IDH indahash",
  "EDG edgeless",
  "SPC spacechain",
  "CLOAK cloakcoin",
  "GARD hashgard",
  "GEO geocoin",
  "MNE minereum",
  "VRC vericoin",
  "ATL atlant",
  "LRN loopring-neo",
  "FTX fintrux-network",
  "PST primas",
  "DYN dynamic",
  "HLC halalchain",
  "EXRN exrnchain",
  "INK ink",
  "NTK neurotoken",
  "IMT moneytoken",
  "ART maecenas",
  "IHT iht-real-estate-protocol",
  "HKN hacken",
  "BANCA banca",
  "SPHR sphere",
  "TAC traceability-chain",
  "PRA prochain",
  "DELTA delta-chain",
  "AXPR axpire",
  "MER mercury",
  "ZPR zper",
  "FACE faceter",
  "IQ iqcash",
  "FLIXX flixxo",
  "DPY delphy",
  "PTT proton-token",
  "MGO mobilego",
  "PINK pinkcoin",
  "PHI phi-token",
  "XRA ratecoin",
  "SWM swarm-fund",
  "TEAM tokenstars",
  "TRST trust",
  "AAC acute-angle-cloud",
  "ESP espers",
  "DIT digital-insurance-token",
  "DRT domraider",
  "PYLNT pylon-network",
  "ZAP zap",
  "NBC niobium-coin",
  "EXP expanse",
  "AUC auctus",
  "SNOV snovio",
  "DCT decent",
  "SHIFT shift",
  "ATM attention-token-of-media",
  "BDG bitdegree",
  "AID aidcoin",
  "DROP dropil",
  "ACAT alphacat",
  "NLC2 nolimitcoin",
  "HSC hashcoin",
  "ORMEUS ormeus-coin",
  "ZPT zeepin",
  "TNC trinity-network-credit",
  "NVC novacoin",
  "MTC mtc-mesh-network",
  "ION ion",
  "XEL elastic",
  "KRB karbo",
  "SIB sibcoin",
  "ADB adbank",
  "OCT oraclechain",
  "DAV dav-coin",
  "ONL on-live",
  "STX stox",
  "VIEW view",
  "RATING dprating",
  "FYP flypme",
  "MEME memetic",
  "TIPS fedoracoin",
  "FXT fuzex",
  "PTOY patientory",
  "SWT swarm-city",
  "AMN amon",
  "QBT qbao",
  "DOPE dopecoin",
  "YOC yocoin",
  "CRC crycash",
  "ZP zen-protocol",
  "FLP flip",
  "MSP mothership",
  "ESS essentia",
  "RED red",
  "ZLA zilla",
  "DBIX dubaicoin-dbix",
  "ELEC electrifyasia",
  "ERT eristica",
  "NANJ nanjcoin",
  "BEZ bezop",
  "AVT aventus",
  "KARMA karma-eos",
  "ADT adtoken",
  "VRM veriumreserve",
  "DOLLAR dollar-online",
  "SPD spindle",
  "W3C w3coin",
  "MNX minexcoin",
  "EXCL exclusivecoin",
  "DIM dimcoin",
  "XBP blitzpredict",
  "HGT hellogold",
  "LATX latiumx",
  "IDXM idex-membership",
  "SEN consensus",
  "FOTA fortuna",
  "GBX gobyte",
  "IPSX ip-exchange",
  "SS sharder",
  "SWING swing",
  "GUP guppy",
  "RLX relex",
  "PBT primalbase",
  "BNTY bounty0x",
  "CMCT crowd-machine",
  "HXX hexx",
  "BSD bitsend",
  "CCRB cryptocarbon",
  "OPT opus",
  "EVC eventchain",
  "XNK ink-protocol",
  "ATMI atonomi",
  "ADH adhive",
  "SCL sociall",
  "COB cobinhood",
  "EL elcoin-el",
  "DTH dether",
  "INSN insanecoin-insn",
  "TRUMP trumpcoin",
  "UNIFY unify",
  "STAR starbase",
  "RMESH rightmesh",
  "TSL energo",
  "ADI aditus",
  "DAY chronologic",
  "BON bonpay",
  "CDX commodity-ad-network",
  "IXT ixledger",
  "SEXC sharex",
  "ZMN zmine",
  "SNTR silent-notary",
  "OXY oxycoin",
  "BCI bitcoin-interest",
  "FTT farmatrust",
  "SDS alchemint-standards",
  "BTB bitbar",
  "BERRY rentberry",
  "FLOT fire-lotto",
  "BBT bitboost",
  "HB heartbout",
  "KZC kzcash",
  "ESN ethersocial",
  "ELY elysian",
  "BMH blockmesh",
  "PUT putincoin",
  "PUT profile-utility-token",
  "PKG pkg-token",
  "SCT soma",
  "VRS veros",
  "GEM gems-protocol",
  "ARC arcticcoin",
  "HUR hurify",
  "SUR suretly",
  "SPF sportyco",
  "HOLD hold",
  "SKIN skincoin",
  "SSC selfsell",
  "BTA bata",
  "GET get-protocol",
  "ITI iticoin",
  "CPC capricoin",
  "GIN gincoin",
  "ERO eroscoin",
  "CTX cartaxi-token",
  "HER heronode",
  "TX transfercoin",
  "GB goldblocks",
  "PYN paycent",
  "MORE more-coin",
  "SONIQ soniq",
  "ITT intelligent-trading-foundation",
  "CYFM cyberfm",
  "MOIN moin",
  "NOX nitro",
  "BTRN biotron",
  "MOJO mojocoin",
  "POST postcoin",
  "NRP neural-protocol",
  "NPER nper",
  "SPK sparks",
  "XAP apollon",
  "MNC mincoin",
  "DSR desire",
  "TOTO tourist-token",
  "LUNA luna-coin",
  "MICRO micromines",
  "FGC fantasygold",
  "FTXT futurax",
  "MASH masternet",
  "KUN kun",
  "PMNT paymon",
  "RLT roulettetoken",
  "APIS apis",
  "DIG dignity",
  "TRI triangles",
  "ORE galactrum",
  "SGA saga",
  "FIL filecoin",
  "MT mytoken",
  "XUC exchange-union",
  "PLY playcoin",
  "VTHO vethor-token",
  "TOPC topchain",
  "STC starchain",
  "SHE shinechain",
  "CRE cybereits",
  "KEY key",
  "MEET coinmeet",
  "BU bumo",
  "EDU edu-coin",
  "HDAC hdac",
  "MAG maggie",
  "UCT ubique-chain-of-things",
  "IIC intelligent-investment-chain",
  "CMS comsa-eth",
  "MSD msd",
  "BCX bitcoinx",
  "CMS comsa-xem",
  "QUBE qube",
  "PXC pixie-coin",
  "BCDN blockcdn",
  "DACC dacc",
  "LPT livepeer",
  "CDC commerce-data-connection",
  "XIN infinity-economics",
  "SOP sopay",
  "SBTC super-bitcoin",
  "TV ti-value",
  "LEMO lemochain",
  "PRES president-trump",
  "BIT first-bitcoin",
  "GSE gsenetwork",
  "USE usechain-token",
  "CFC coffeecoin",
  "TER terranova",
  "EDS endorsit",
  "BIFI bitcoin-file",
  "SCC stockchain",
  "WIKI wiki-token",
  "FTO futurocoin",
  "EPC electronic-pk-chain",
  "INC influence-chain",
  "ORS ors-group",
  "CLUB clubcoin",
  "GOD bitcoin-god",
  "CAR carblock",
  "0XBTC 0xbtc",
  "1WO 1world",
  "2GIVE 2give",
  "42 42-coin",
  "KWATT 4new",
  "808 808coin",
  "8BIT 8bit",
  "RTB ab-chain-rtb",
  "AAA abulaba",
  "AC3 ac3",
  "ACC acchain",
  "ACED aced",
  "ACE ace",
  "ACC adcoin",
  "ADS adshares",
  "XXX adultchain",
  "AIB advanced-internet-blocks",
  "ADZ adzcoin",
  "AEG aegeus",
  "AIX aigang",
  "ALI ailink-token",
  "ABL airbloc",
  "AKY akuya-coin",
  "ALX alax",
  "ALIS alis",
  "ALL allion",
  "ASAFE allsafe",
  "ABC alphabitcoinfund",
  "AMMO ammo-reloaded",
  "AMS amsterdamcoin",
  "ACP anarchistsprime",
  "AVH animation-vision-cash",
  "ANI animecoin",
  "ANC anoncoin",
  "RYZ anryze",
  "APH aphelion",
  "APL apollo-currency",
  "APR apr-coin",
  "APX apx",
  "ARCO aquariuscoin",
  "ARB arbitrage",
  "ARCT arbitragect",
  "ACTP archetypal-network",
  "ARG argentum",
  "ARGUS argus",
  "ARI aricoin",
  "ARION arion",
  "ARLIZE arlize",
  "ABY artbyte",
  "XAS asch",
  "AC asiacoin",
  "ADCN asiadigicoin",
  "ATX aston",
  "ATB atbcoin",
  "ATCC atc-coin",
  "ATMOS atmos",
  "AUR auroracoin",
  "AURA aurora-dao",
  "AU aurumcoin",
  "NIO autonio",
  "ACN avoncoin",
  "AT aware",
  "BAAS baasid",
  "BKX bankex",
  "BBN banyan-network",
  "BSN bastonet",
  "BITB bean-cash",
  "BEE bee-token",
  "BELA belacoin",
  "BENJI benjirolls",
  "BET betacoin",
  "BETR betterbetting",
  "BBP biblepay",
  "BBO bigbom",
  "BIGUP bigup",
  "XBL billionaire-token",
  "BIO biocoin",
  "BIRDS birds",
  "BIS bismuth",
  "BAY bitbay",
  "BBK bitblocks",
  "CAT bitclave",
  "BTDX bitcloud",
  "BEN bitcoen",
  "BCF bitcoinfast",
  "BITG bitcoin-green",
  "BTPL bitcoin-planet",
  "XBC bitcoin-plus",
  "BTCP bitcoin-private",
  "BTCRED bitcoin-red",
  "BTCS bitcoin-scrypt",
  "BTCZ bitcoinz",
  "BCY bitcrystals",
  "BTCR bitcurrency",
  "BDL bitdeal",
  "CSNO bitdice",
  "STU student-coin",
  "BPC bitpark-coin",
  "BQ bitqy",
  "BRO bitradio",
  "RNTB bitrent",
  "BIT bitrewards",
  "BITX bitscreener-token",
  "BSR bitsoar",
  "BSTN bitstation",
  "BITS bitswift",
  "BXT bittokens",
  "ZNY bitzeny",
  "BLAZR blazercoin",
  "ARY block-array",
  "BQT blockchain-quotations-index-token",
  "LNC blocklancer",
  "BND blocknode",
  "BPL blockpool",
  "TIX blocktix",
  "BTT blocktrade",
  "BLT bloomtoken",
  "BLUE ethereum-blue",
  "BOAT doubloon",
  "BOB bobs-repair",
  "BOT bodhi",
  "BOE bodhi-eth",
  "BLN bolenum",
  "BOLI bolivarcoin",
  "AHT bowhead",
  "BOXX boxx-token-blockparty",
  "BRM brahmaos",
  "BRK breakout",
  "BRX breakout-stake",
  "BBK brickblock",
  "BRIT britcoin",
  "BNN brokernekonetwork",
  "BRAT brat",
  "BUBO budbo",
  "CBX bullion",
  "BWK bulwark",
  "BUMBA bumbacoin",
  "BUN bunnycoin",
  "BUNNY bunnytoken",
  "BUZZ buzzcoin",
  "CC campuscoin",
  "CDN canada-ecoin",
  "CANDY candy",
  "CANN cannabiscoin",
  "CNNC cannation",
  "CIT carinet",
  "IOV carlive-chain",
  "CAS cashaa",
  "CBC cashbery-coin",
  "CAT catcoin",
  "CATO catocoin",
  "XCT c-bit",
  "CEDEX cedex-coin",
  "CFUN cfun",
  "CHX chainium",
  "CHESS chesscoin",
  "CHIPS chips",
  "COVAL circuits-of-value",
  "CTL citadel",
  "CLAM clams",
  "XCLR clearcoin",
  "POLL clearpoll",
  "CFI cofound-it",
  "CTIC3 coimatic-3",
  "CL coinlancer",
  "CNO coin",
  "CXT coinonat",
  "XCXT coinonatx",
  "COIN coinvest",
  "COLX colossusxt",
  "CLN colu-local-network",
  "COMP compound-coin",
  "CCC concierge-coin",
  "RAIN condensate",
  "CDM condominium",
  "CONI coni",
  "CJT connectjob",
  "CSM consentium",
  "CAN content-and-ad-network",
  "CNET contractnet",
  "CPY copytrack",
  "COR corion",
  "COSM cosmo-coin",
  "COSS coss",
  "COU couchain",
  "COUPE coupecoin",
  "CRAVE crave",
  "CRM cream",
  "CREA creativecoin",
  "CRDNC credence-coin",
  "CREDO credo",
  "CREVA crevacoin",
  "CROP cropcoin",
  "YUP crowdholding",
  "CHE crypto-harbor-exchange",
  "CIF crypto-improvement-fund",
  "CJ cryptojacks",
  "CNX cryptonex",
  "XCN cryptonite",
  "CEFS cryptopiafeeshares",
  "CST cryptosolartech",
  "CCT crystal-clear",
  "AUTO cube",
  "QBT cubits",
  "CVN cvcoin",
  "CYMT cybermusic",
  "CYDER cyder",
  "DACS dacsee",
  "DALC dalecoin",
  "DAN daneel",
  "DAPS daps-token",
  "KED darsek",
  "DTB databits",
  "DTC datacoin",
  "DXT datawallet",
  "DBTC debitcoin",
  "DEB debitum-network",
  "DBET decent-bet",
  "HST decision-token",
  "ONION deeponion",
  "DEEX deex",
  "DEUS deuscoin",
  "DEM deutsche-emark",
  "EVE devery",
  "DEV deviantcoin",
  "DEW dew",
  "DGC digitalcoin",
  "DMB digital-money-bits",
  "DP digitalprice",
  "DRS digital-rupees",
  "DCY dinastycoin",
  "DIN dinero",
  "DPN dipnet",
  "DCC distributed-credit-chain",
  "DIVI divi",
  "MTC docademic",
  "DOR dorado",
  "DOT dotcoin",
  "DFT draftcoin",
  "DGS dragonglass",
  "DRXNE droxne",
  "DUTCH dutch-coin",
  "DWS dws",
  "DMC dynamiccoin",
  "DTEM dystem",
  "EAC earthcoin",
  "EARTH earth-token",
  "EBC ebcoin",
  "EBTC ebtcnew",
  "EBT ebittree-coin",
  "EBST eboostcoin",
  "ECC eccoin",
  "ECO ecocoin",
  "EDR e-dinar-coin",
  "EDRC edrcoin",
  "LEDU education-ecosystem",
  "EFL e-gulden",
  "EJOY ejoy",
  "ECA electra",
  "ELE elementrem",
  "ELI eligma-token",
  "1337 1337coin",
  "ELIX elixir",
  "ELLA ellaism",
  "ELS elysium",
  "EMB embercoin",
  "MBRS embers",
  "EMD emerald",
  "EPY emphy",
  "ETT encryptotel",
  "ETK energitoken",
  "ENGT engagement-token",
  "ENT entcash",
  "BLACK eosblack",
  "EQL equal",
  "EQT equitrader",
  "ERA blakestar",
  "ERY eryllium",
  "EST esports-token",
  "XET eternal-token",
  "ENT eternity",
  "ETBS ethbits",
  "ETHD ethereum-dark",
  "ETG ethereum-gold",
  "RIYA etheriya",
  "ERC europecoin",
  "EGC evergreencoin",
  "EVR everus",
  "EVIL evil-coin",
  "EXC excaliburcoin",
  "EXC eximchain",
  "EXMR exmr",
  "XP experience-points",
  "EZT eztoken",
  "FT fabric-token",
  "FAIR faircoin",
  "FAIR fairgame",
  "FANS fantasy-cash",
  "FCN fantomcoin",
  "FAP fapcoin",
  "BITCF first-bitcoin-capital",
  "FLASH flash",
  "FLIK flik",
  "FNKOS fnkos",
  "FLDC foldingcoin",
  "FLM folmcoin",
  "FONZ fonziecoin",
  "FOOD food",
  "FORK forkcoin",
  "FMF formosa-financial",
  "FSBT forty-seven-bank",
  "FREC freyrchain",
  "FJC fujicoin",
  "NTO fujinto",
  "FUZZ fuzzballs",
  "GNR gainer",
  "GAM gambit",
  "GCS gamechain",
  "GRLC garlicoin",
  "GAT gatcoin",
  "GZE gazecoin",
  "GCN gcn-coin",
  "GEERT geertcoin",
  "GLA gladius-token",
  "GLS glasscoin",
  "BSTY globalboost-y",
  "GLT globaltoken",
  "GLC goldcoin",
  "GMX goldmaxcoin",
  "GP goldpieces",
  "GPKR gold-poker",
  "GRX gold-reward-token",
  "GOLF golfcoin",
  "GBG golos-gold",
  "GOOD goodomy",
  "GRFT graft",
  "GDC grandcoin",
  "GRPH graphcoin",
  "GRE greencoin",
  "GRMD greenmed",
  "GRC gridcoin",
  "GRIM grimcoin",
  "GRWI growers-international",
  "GETX guaranteed-ethurance-token-extra",
  "HAC hackspace-capital",
  "HALLO halloween-coin",
  "HPC happycoin",
  "HRC haracoin",
  "HC harvest-masternode-coin",
  "HAVY havy",
  "WORM healthywormcoin",
  "HEAT heat-ledger",
  "HBZ helbiz",
  "HNC helleniccoin",
  "THC hempcoin",
  "HERO hero",
  "XHI hicoin",
  "HIGH high-gain",
  "HMC hi-mutual-society",
  "HIRE hirematch",
  "HODL hodlcoin",
  "HBC homeblockcoin",
  "HONEY honey",
  "HUM humanscape",
  "HNC huncoin",
  "HUC huntercoin",
  "HUSH hush",
  "HYPER hyper",
  "HYP hyperstake",
  "I0C i0coin",
  "ICN iconomi",
  "ICE idice",
  "IDOL idol-coin",
  "IFOOD ifoods-chain",
  "IC ignition",
  "REX imbrex",
  "IMX impact",
  "NKA incakoin",
  "INDI indicoin",
  "IFC infinitecoin",
  "IFLT inflationcoin",
  "INN innova",
  "INSUR insurchain",
  "INCX internationalcryptox",
  "IOP internet-of-people",
  "ENIX invacio",
  "IFT investfeed",
  "IOUX iou",
  "IPC ipchain",
  "IQT iquant",
  "IRL irishcoin",
  "ING iungo",
  "IVY ivy",
  "IXC ixcoin",
  "JC jesus-coin",
  "J8T jet8",
  "JIN jin-coin",
  "SWTC jingtum-tech",
  "J joincoin",
  "XJO joulecoin",
  "JOT jury-online-token",
  "KNDC kanadecoin",
  "KAYI kayicoin",
  "KEK kekcoin",
  "KIND kind-ads-token",
  "KNT knekted",
  "KOBO kobocoin",
  "KLN kolion",
  "KNT kora-network-token",
  "KORE korecoin",
  "KBR kubera-coin",
  "KURT kurrent",
  "LALA lala-world",
  "PIX lampix",
  "LDC leadcoin",
  "LEAF leafcoin",
  "LST lendroid-support-token",
  "LC4 leocoin",
  "LUC level-up",
  "LEV leverj",
  "XLC leviar",
  "LEVO levocoin",
  "LIGHT lightchain",
  "LPC lightpaycoin",
  "LINA lina",
  "LINDA linda",
  "LFC linfinity",
  "LKC linkedcoin",
  "LNK link-platform",
  "LINX linx",
  "LBTC litebitcoin",
  "LCP litecoin-plus",
  "LDOGE litedoge",
  "LIVE live-stars",
  "LWF local-world-forwarders",
  "LOCI locicoin",
  "LGS logiscoin",
  "LMC lomocoin",
  "LYL loyalcoin",
  "LUX luxcoin",
  "LYNX lynx",
  "XMG magi",
  "MAGN magnetcoin",
  "MGM magnum",
  "MFTU mainstream-for-the-underground",
  "MARS marscoin",
  "MXT martexcoin",
  "MGD massgrid",
  "MVL mass-vehicle-ledger",
  "MTNC masternodecoin",
  "MSCN master-swiscoin",
  "MVC maverick-chain",
  "MAVRO mavro",
  "MXM maximine-coin",
  "MEDX medx",
  "MEDIC mediccoin",
  "MEETONE meetone",
  "MEC megacoin",
  "MAS midasprotocol",
  "MILO milocoin",
  "MRT miners-reward-token",
  "MINEX minex",
  "MINT mintcoin",
  "MRI mirai",
  "MOD modum",
  "XMO monero-original",
  "XMCC monacocoin",
  "MCC moving-cloud-coin",
  "MUSIC musicoin",
  "MCI musiconomi",
  "MST mustangcoin",
  "WISH mywish",
  "NAM nam-coin",
  "NRVE narrative",
  "NTC natcoin",
  "NAVI naviaddress",
  "NBAI nebula-ai",
  "NEOG neo-gold",
  "NEOS neoscoin",
  "NET netcoin",
  "NETKO netko",
  "NRO neuro",
  "NTRN neutron",
  "NEVA nevacoin",
  "NDC neverdie",
  "NPW new-power-coin",
  "NXC nexium",
  "NTY nexty",
  "NOBL noblecoin",
  "NOBS no-bs-crypto",
  "NLX nullex",
  "NMS numus",
  "NUSD nusd",
  "NYAN nyancoin",
  "ODN obsidian",
  "OC oceanchain",
  "OCL oceanlab",
  "888 octocoin",
  "OF ofcoin",
  "MOT olympus-labs",
  "OMNI omni",
  "ECOM omnitude",
  "RNT oneroot-network",
  "ONX onix",
  "OPC op-coin",
  "OPCX opcoinx",
  "OTN open-trading-network",
  "ORB orbitcoin",
  "ORS origin-sport",
  "CHX own",
  "PCS pabyosi-coin-special",
  "PAC paccoin",
  "PAK pakcoin",
  "PND pandacoin-pnd",
  "PRG paragon",
  "DUO parallelcoin",
  "PARETO pareto-network",
  "PASC pascal-coin",
  "PASL pascal-lite",
  "PAT patron",
  "XPY paycoin2",
  "CON paycon",
  "PDX payday-coin",
  "PFR payfair",
  "PCN peepcoin",
  "GUESS guess",
  "PENG penguin-coin",
  "PEPECASH pepe-cash",
  "PTC pesetacoin",
  "PXC phoenixcoin",
  "PHR phore",
  "PHO photon",
  "PIGGY piggycoin",
  "PCOIN pioneer-coin",
  "SKULL pirate-blocks",
  "PIRL pirl",
  "PTS pitiscoin",
  "XPTX platinumbar",
  "PLACO playercoin",
  "IOG playgroundz",
  "PLX plexcoin",
  "PLC polcoin",
  "PAL policypal-network",
  "POLIS polis",
  "PCH popchain",
  "POP popularcoin",
  "POS postoken",
  "PSM prasm",
  "XPM primecoin",
  "PRIMU primulon",
  "PRX printerium",
  "PROC procurrency",
  "PGL prospectors-gold",
  "PRN protean",
  "PROUD proud-money",
  "XES proxeus",
  "PBL publica",
  "PURA pura",
  "PUREX purex",
  "VIDZ purevidz",
  "QAC quasarcoin",
  "XQN quotient",
  "QURO qurito",
  "QVT qvolta",
  "QWARK qwark",
  "RBBT rabbitcoin",
  "RHOC rchain",
  "READ read",
  "RCT realchain",
  "REBL rebl",
  "RED redcoin",
  "REF reftoken",
  "RNS renos",
  "RTL rentledger",
  "RVR revolutionvr",
  "XRE revolvercoin",
  "XRH rhenium",
  "XRL rialto",
  "RVT rivetz",
  "RKT rock",
  "ROOFS roofs",
  "RRC rrcoin",
  "RBLX rublix",
  "RBY rubycoin",
  "RUNNERS runners",
  "RUP rupee",
  "RMC russian-mining-coin",
  "RYO ryo-currency",
  "SAFEX safe-exchange-coin",
  "XSTC safe-trade-coin",
  "SAGA sagacoin",
  "SKR sakuracoin",
  "SAL salpay",
  "SPN sapien",
  "SVD savedroid",
  "SCORE scorecoin",
  "SRC securecoin",
  "SEER seer",
  "B2X segwit2x",
  "SDRN senderon",
  "UPP sentinel-protocol",
  "SEQ sequence",
  "SHA shacoin",
  "SHP sharpe-platform-token",
  "JEW shekel",
  "XSH shield-xsh",
  "OMX shivom",
  "SHOW show",
  "HAND showhand",
  "SIGMA sigmacoin",
  "SISA sisa",
  "SDA six-domain-chain",
  "611 sixeleven",
  "SKC skeincoin",
  "SLOTH slothcoin",
  "SMC smartcoin",
  "SSP smartshare",
  "SMLY smileycoin",
  "SNIP snipcoin",
  "SOAR soarcoin",
  "SEND social-send",
  "SOIL soilcoin",
  "SFC solarflarecoin",
  "XLR solaris",
  "SPHTX sophiatx",
  "SPX sp8de",
  "SPACE spacecoin",
  "SPANK spankchain",
  "SIG signal-token",
  "SXUT spectre-utility",
  "SCS speedcash",
  "SMS speed-mining-service",
  "XID sphre-air",
  "SPR spreadcoin",
  "SPRTS sprouts",
  "SRCOIN srcoin",
  "KST starcointv",
  "STA starta",
  "STAC startercoin",
  "HOLD interstellar-holdings",
  "STN steneum-coin",
  "STQ storiqa",
  "SJCX storjcoin-x",
  "STAK straks",
  "SHND stronghands",
  "SGR sugar-exchange",
  "SUPER supercoin",
  "UNITY supernet-unity",
  "SIC swisscoin",
  "SWTH switcheo",
  "MFG syncfab",
  "SYNX syndicate",
  "TAJ tajcoin",
  "TALAO talao",
  "TGT target-coin",
  "TTU tatatu",
  "TLE tattoocoin-limited",
  "TSE tattoocoin",
  "TCN tcoin",
  "THS techshares",
  "TEK tekcoin",
  "TELL tellurion",
  "TRC terracoin",
  "TESLA teslacoilcoin",
  "TES teslacoin",
  "TMTG the-midas-touch-gold",
  "GET themis",
  "MAY theresa-may-coin",
  "THRT thrive-token",
  "TIE tiesdb",
  "TGC tigercoin",
  "TIT titcoin",
  "TIT tittiecoin",
  "TOA toacoin",
  "TDS tokendesk",
  "TEN tokenomy",
  "TKS tokes",
  "TKA tokia",
  "TOK tokugawa",
  "TOPAZ topaz",
  "TOR torcoin-tor",
  "TRCT tracto",
  "BBC b2bcoin",
  "TM2 traxia",
  "TZC trezarcoin",
  "TRDT trident",
  "TTY trinity",
  "TRTT trittium",
  "TROLL trollcoin",
  "TRK truckcoin",
  "TTT trustnote",
  "TURBO turbocoin",
  "TWIST twist",
  "UCN uchain",
  "UGC ugchain",
  "UNC uncoin",
  "UFO uniform-fiscal-object",
  "UBTC united-bitcoin",
  "UIS unitus",
  "UNIT universal-currency",
  "UNO unobtanium",
  "UP uptoken",
  "OOT utrum",
  "VPRC vaperscoin",
  "VLTC vault-coin",
  "CRED verify",
  "VME verime",
  "V version",
  "VZT vezt",
  "VIT vice-industry-token",
  "VIPS vipstar-coin",
  "VTA virtacoin",
  "XVP virtacoinplus",
  "VC virtualcoin",
  "VISIO visio",
  "VITAE vitae",
  "VIU viuly",
  "VIVO vivo",
  "VOISE voisecom",
  "ACDC volt",
  "VOT votecoin",
  "VSC vsportcoin",
  "VSX vsync-vsx",
  "VULC vulcano",
  "WAB wabnetwork",
  "WAND wandx",
  "WGO wavesgo",
  "WSX wearesatoshi",
  "WEB webcoin",
  "WHL whalecoin",
  "WIC wi-coin",
  "WILD wild-crypto",
  "WC win-coin",
  "WIN wintoken",
  "WIT witchain",
  "WOMEN women",
  "WRC worldcore",
  "WWB wowbit",
  "XCEL xceltoken",
  "XCG xchange",
  "XCO x-coin",
  "XDNA xdna",
  "XNN xenon",
  "XGOX xgox",
  "XMCT xmct",
  "XRT xrt-token",
  "XBY xtrabytes",
  "XTRD xtrd",
  "YTN yenten",
  "YUKI yuki",
  "ZCL zclassic",
  "ZCO zebi",
  "ZEIT zeitcoin",
  "ZEL zelcash",
  "ZENI zennies",
  "ZNT zenswap-network-token",
  "ZEST zest",
  "ZET zetacoin",
  "ZMC zetamicron",
  "ZINC zinc",
  "ZIP zip",
  "ZIPT zippie",
  "ZZC zozocoin",
];
